import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import axiosInstance from "api/axiosInstance";
import FloatingStepper from "units/components/FloatingStepper/FloatingStepper";

// 🌗 استایل توکن‌های لندینگ — قبل از هر کامپوننت
import "./styles/theme.css";

import Navbar from "./sections/Navbar";
import HeroSection from "./sections/HeroSection/index";
import WhyRayaBot from "./sections/whyRayaBot/index";
import ActiveBotsSlider from "./components/ActiveBotsSlider/ActiveBotsSlider";
import LandingPlans from "./components/LandingPlans";
import Articles from "./components/Articles";
import VIPplan from "./components/VIPplan";
import LandingFooter from "./sections/Footer/index";
import ChatButton from "./components/ChatButton";
import Background from "./components/Background/index";
import Marquee from "./sections/Marquee/index";
import Demo from "./sections/Demo/index";
import StatsBand from "./sections/StatsBand/index";
import Showcase from "./sections/Showcase/index";
import Testimonials from "./sections/Testimonials/index";
import Pricing from "./sections/Pricing/index";
import FAQ from "./sections/FAQ/index";
export default function Landing() {
  const [steps, setSteps] = useState();

  const heroRef = useRef(null);
  const whyRef = useRef(null);
  const botBenefitsRef = useRef(null);
  const activeBotsRef = useRef(null);
  const landingPlansRef = useRef(null);
  const articlesRef = useRef(null);
  const vipPlanRef = useRef(null);
  const footerRef = useRef(null);

  const sections = {
    hero: heroRef,
    why: whyRef,
    botBenefits: botBenefitsRef,
    activeBots: activeBotsRef,
    landingPlans: landingPlansRef,
    articles: articlesRef,
    vipPlan: vipPlanRef,
    callToUs: footerRef,
  };

  useEffect(() => {
    const getRoadmap = async () => {
      try {
        const res = await axiosInstance.get("business/@me/roadmap");
        if (res?.data?.ok) setSteps(res?.data?.data.nodes);
      } catch (err) {
        console.error("Error fetching bots:", err);
      }
    };
    getRoadmap();
  }, []);

  return (
    <div className="relative isolate min-h-screen w-full max-w-full overflow-x-clip bg-canvas text-ink transition-colors duration-500">
      <Background />
      <Helmet>
        <html lang="fa" dir="rtl" />
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>رایابات - پلتفرم چت بات هوشمند</title>
        <meta
          name="description"
          content="پلتفرم چت‌بات پیشرفته با هوش مصنوعی، پردازش متن و گفتار، تحلیل داده‌ها و داشبورد مدیریتی."
        />
        <meta
          name="keywords"
          content="چت بات, هوش مصنوعی, گفتار به متن, تحلیل داده, رایابات"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Navbar جدید — با prop sections سازگار */}
      <Navbar sections={sections} />

      <main>
        <section ref={heroRef} id="hero" className="scroll-mt-24">
          <HeroSection />
        </section>
      </main>

      <Marquee />

      <main>
        <section ref={whyRef} id="why" className="scroll-mt-24">
          <WhyRayaBot />
        </section>

        <Demo />

        <StatsBand />

        <section ref={activeBotsRef} id="activeBots" className="scroll-mt-24">
          <ActiveBotsSlider />
        </section>

        <Showcase />

        <Testimonials />

        <Pricing />

        <FAQ />

      </main>

      <div ref={footerRef}>
        <LandingFooter />
      </div>

      <ChatButton />
    </div>
  );
}